import {ThemedPressable, ThemedText, ThemedView} from '@app/theme';
import {
  FlatList,
  ScrollView,
  TouchableOpacity,
  View,
  StyleSheet,
} from 'react-native';
import PleadegedAssetInfo from '../PleadgeMF/PleadegedAssetInfo';
import Button from '@app/sharedComponents/Button/Button';
import { useState } from 'react';
import CheckBox from '@app/sharedComponents/CheckBox/CheckBox';

const FilterComponent = ({
  filtersSections,
  assetList,
  setFilteredList,
  filteredList,
  onFilterCheckBoxPressed,
  checkedFilters,
  onEditAmountPressed,
  setCheckedFilters,
  setFilteredAssetList,
  setTempFilteredAssetList,
  onApplyFilterPressed,
  selectedFilter 
}) => {
  

const [activeFilter, setActiveFilter] = useState('EQUITY')

const renderSelectAllCheckBox = () => {
  return(
  <ThemedView>
  <ThemedView flexDirection="row" justifyContent="space-between" >
      <ThemedView flex={2} flexDirection="row">
          {true && <ThemedPressable mt="xs">
          <CheckBox
                  size={20}
                  onToggle={()=>{
                  }}
                  isChecked={false}
              />
          </ThemedPressable>}
          <ThemedText  variant="b3r" color="text-primary">{"Select all"}</ThemedText>
      </ThemedView>
      
  </ThemedView>
  <ThemedView height={1} backgroundColor="border-primary" width="100%" my="lg" />
</ThemedView>
  )
}
  return (
    <ThemedView height={554}>
      <ThemedText margin="lg" variant="b2s" color="text-primary" mb="lg">
        Filter
      </ThemedText>

      <ThemedView height={1} bg="border-primary" width={'100%'}></ThemedView>
      <ThemedView flexDirection="row">
        <ThemedView>
          <FlatList
            style={[{width: 150, backgroundColor: '#F0F0F3', height: 500}]}
            data={filtersSections}
            renderItem={({item}) => (
              <ThemedView borderBottomWidth={1} borderColor='border-primary' >
                <TouchableOpacity
                  style={{
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    padding: 20,
                  }}
                  onPress={() => {
                    console.log('ITEM', item);
                    const assetTypeToFilter = item;
                    const equityFunds = assetList.filter(
                      (item) => item.assetSubType === assetTypeToFilter,
                    );

                    console.log('EQUITY FUNDS', activeFilter, item);
                    console.log("Filtered funds are", equityFunds)
                    setFilteredList(equityFunds);
                    setActiveFilter(item)
                   
                  }}>
                  {<ThemedText variant= { activeFilter === item ? "b3m" :   "b3r"} color={activeFilter === item ? 'text-primary' : 'text-secondary'}> {item}</ThemedText>}
                </TouchableOpacity>
              </ThemedView>
            )}></FlatList>
        </ThemedView>

        <ThemedView flex={1} paddingBottom='lg'>

          <ScrollView style={{margin: 16}} contentContainerStyle={{height : 100}}>

            {filteredList.map((filteredList : any, index : number) => (
              <PleadegedAssetInfo
                key={index}
                position={index}
                asset={filteredList}
                isEdit={true}
                onCheckboxPressed={onFilterCheckBoxPressed}
                pledgedList={checkedFilters}
                onEditAmountPressed={onEditAmountPressed}
                showCreditLimit={false}
              />
            ))}
          </ScrollView>
        </ThemedView>
      </ThemedView>
      <ThemedView
        height={56}
        width={'100%'}
        position="absolute"
        bottom={0}
        flexDirection="row"
        backgroundColor="bg-fill-primary">
        <ThemedView flex={1} justifyContent="center" margin="lg">
          <Button
            label={'Reset filter'}
            type="OUTLINED"
            size="MD"
            handlePress={() => {
              setCheckedFilters([]);
              setFilteredAssetList(assetList);
              setTempFilteredAssetList(assetList);
            }}
            disabled={false}
          />
        </ThemedView>
        <ThemedView flex={1} justifyContent="center" margin="lg">
          <Button
            label={'Apply filter'}
            size="MD"
            handlePress={() => {
              onApplyFilterPressed();
            }}
            disabled={false}
          />
        </ThemedView>
      </ThemedView>
    </ThemedView>
  );
};

export default FilterComponent;

const styles = StyleSheet.create({});
